exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-icon.mdi.mdi-eye.theme--light {\n  color: green;\n}\n.sortable-chosen {\n  border: 1px solid #0d73d8;\n  /*transform:none!important;;*/\n}\n", ""]);

